import { string } from "yup";

export const email = () =>
  string()
    .email("Email is not valid. Example email: example@example.com")
    .max(100, "Email is too long.")
    // Check if the local part of the email is valid
    .test("email-local-length", "Email is not valid.", (val) => {
      if (!val) return true;
      const [local] = val.split("@");
      return !!local && local.length <= 64;
    })
    .test(
      "email-domain-dot",
      "Email is not valid. Example email: example@example.com",
      (val) => {
        if (!val) return true;
        const [, domain] = val.split("@");
        return !!domain && domain.includes(".");
      }
    )
    .transform((value) => (!value ? "" : value));

export const emailOptional = () => email().nullable().optional();
export const emailRequired = () => email().required("Email is required");
